<script setup lang="ts">
  import { Text } from "@ui-kit";

  const { title, countTotal, isCollected, isCanceled } = defineProps<{
    title: string;
    countCollected: number;
    countTotal: number;
    isCanceled: boolean;
    isCollected: boolean;
  }>();
</script>

<template>
  <div
    class="order-card-item-picking-column"
    :class="{
      'success': isCollected,
      'danger': isCanceled,
      'warning': countCollected > 0 && countCollected < countTotal,
    }"
  >
    <div class="cell">
      <Text font="body-medium-18">{{ title }}</Text>
    </div>
    <div class="cell">
      <Text font="body-regular-18">{{ countTotal }}</Text>
    </div>
    <div class="cell">
      <Text font="body-regular-18">{{ countCollected }}</Text>
    </div>
  </div>
</template>

<style scoped>
  .order-card-item-picking-column {
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 4px;
    border-radius: 12px;
    overflow: hidden;

    &.success .cell {
      background-color: var(--sf-size-background-success-default);

      & :deep(.text) {
        color: var(--sf-size-text-success);
      }
    }

    &.warning .cell {
      background-color: var(--sf-size-background-warning-default);

      & :deep(.text) {
        color: var(--sf-size-text-warning);
      }
    }

    &.danger .cell {
      background-color: var(--sf-size-background-error-default);

      & :deep(.text) {
        color: var(--sf-size-text-error);
      }
    }

    .cell {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      background-color: var(--sf-base-background-primary);
    }
  }
</style>
